function initQuantitySelectors() {
    document.querySelectorAll('[data-quantity-selector]').forEach((selector) => {
        const input = selector.querySelector('[data-quantity-input]');
        const decreaseBtn = selector.querySelector('[data-quantity-decrease]');
        const increaseBtn = selector.querySelector('[data-quantity-increase]');

        if (!input || !decreaseBtn || !increaseBtn) {
            return;
        }

        const min = parseInt(input.min, 10) || 1;

        decreaseBtn.addEventListener('click', () => {
            input.value = Math.max(min, (parseInt(input.value, 10) || min) - 1);
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });

        increaseBtn.addEventListener('click', () => {
            input.value = (parseInt(input.value, 10) || min) + 1;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });

        input.addEventListener('change', () => {
            input.value = Math.max(min, parseInt(input.value, 10) || min);
        });
    });
}

export default initQuantitySelectors;
